import { Select } from "antd";
import { SelectComPesquisa } from "../../../../SelectComPesquisa";
import { useListar } from "../../../../../Services/Financeiro/Titulo/TituloSituacaoService";

interface ITituloSituacaoSelectProps extends Omit<React.ComponentProps<typeof Select>, "value" | "onChange" | "showSearch" | "optionFilterProp" | "filterOption"> {
    value ?: number;
}
export default function TituloSituacaoSelect({
    ...props
}:ITituloSituacaoSelectProps) {
    const {
        data,
        isLoading
    } = useListar({
        //ativo : true
    });

    return <SelectComPesquisa
        {...props}
        placeholder={"Selecione"}
        allowClear
        loading={isLoading}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}